export default {"src":"/_next/static/media/discord_white.58008a83.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};